var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconUnifiedPlatform = function SvgIconUnifiedPlatform(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 111,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-unified-platform_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    x: 10,
    fill: "url(#icon-unified-platform_svg__b)",
    rx: 21,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m40.318 37.998 8.287 5.202.294.184a2.137 2.137 0 0 0 2.202 0l.295-.184 8.286-5.202 2.351-1.476 1.791-1.124c.521-.607.82-1.36.82-2.155 0-1.152-.616-2.226-1.648-2.874l-10.86-6.816c-1.277-.802-2.994-.802-4.272 0l-10.86 6.816c-1.032.648-1.648 1.722-1.648 2.874 0 .794.298 1.548.819 2.153l1.792 1.125 2.35 1.477Zm10.313.53c-.369.229-.893.229-1.262 0l-3.153-1.962-3.604-2.243c-1.364-.85-.108-3.012 1.262-2.16L50 35.977l6.126-3.812c1.372-.853 2.625 1.31 1.262 2.159l-3.49 2.172-3.267 2.033ZM52.43 52.438c-1.414.887-3.454.882-4.86-.001L37.951 46.4l-2.118-1.33a3.263 3.263 0 0 0-.477 1.686c0 1.152.615 2.227 1.647 2.875l10.86 6.816c1.259.79 2.992.804 4.273 0l10.86-6.817c1.032-.647 1.648-1.722 1.648-2.874 0-.6-.17-1.177-.477-1.685l-2.119 1.33s-9.608 6.03-9.617 6.037Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0C0B0",
    d: "M40.176 44.844 48.9 50.32a2.139 2.139 0 0 0 2.201 0l8.724-5.476 2.352-1.476 1.056-.662c.886-.657 1.411-1.647 1.411-2.705 0-.652-.202-1.275-.56-1.813l-2.118 1.329-5.867 3.683-3.669 2.303a4.587 4.587 0 0 1-2.43.684 4.578 4.578 0 0 1-2.43-.684L43.9 43.2l-5.867-3.683-2.118-1.33a3.274 3.274 0 0 0-.56 1.813c0 1.058.526 2.047 1.41 2.703l1.06.665 2.35 1.476Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-unified-platform_svg__b",
    x1: 10,
    x2: 90,
    y1: 58,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F56C4E",
    stopOpacity: 0.84
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icon-unified-platform_svg__a",
    width: 100,
    height: 111,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 11,
    result: "effect1_dropShadow_641_735757"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 21
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.9125 0 0 0 0 0.713268 0 0 0 0 0.585521 0 0 0 0.59 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_641_735757"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_641_735757",
    result: "shape"
  })))));
};
export default SvgIconUnifiedPlatform;